import React, { useRef } from 'react';

type FormFileUploadProps = {
    label: string;
    name: string;
    file?: File | null;
    onChange?: (file: File | null) => void;
    accept?: string;
    error?: string;
    disabled?: boolean;
    required?: boolean;
};

const FormFileUpload = ({ label, name, file, onChange, accept, error, disabled, required }: FormFileUploadProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selected = e.target.files?.[0] || null;
        onChange?.(selected);
    };

    const handleClear = () => {
        onChange?.(null);
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };

    return (
        <div className="mb-4">
            <label htmlFor={name} className="block text-sm font-medium mb-1.5" style={{ color: 'var(--text-secondary)' }}>
                {label}
            </label>
            <div className="flex items-center gap-2">
                <input
                    ref={inputRef}
                    id={name}
                    name={name}
                    type="file"
                    onChange={handleChange}
                    accept={accept}
                    disabled={disabled}
                    required={required}
                    className="hidden"
                />
                <button
                    type="button"
                    onClick={() => inputRef.current?.click()}
                    disabled={disabled}
                    className="btn btn-ghost text-sm"
                    style={{
                        padding: '6px 12px',
                        border: '1px solid var(--border-default)',
                        borderRadius: '0.5rem',
                        cursor: disabled ? 'not-allowed' : 'pointer',
                    }}
                >
                    Choose File
                </button>
                {file ? (
                    <div className="flex items-center gap-2 min-w-0">
                        <span className="text-sm truncate" style={{ color: 'var(--text-primary)', maxWidth: '200px' }}>
                            {file.name}
                        </span>
                        <span className="text-xs" style={{ color: 'var(--text-tertiary)' }}>
                            ({(file.size / 1024).toFixed(1)} KB)
                        </span>
                        <button
                            type="button"
                            onClick={handleClear}
                            className="text-xs"
                            style={{ color: 'var(--danger)', background: 'none', border: 'none', cursor: 'pointer', padding: '2px' }}
                        >
                            ✕
                        </button>
                    </div>
                ) : (
                    <span className="text-sm" style={{ color: 'var(--text-tertiary)' }}>No file selected</span>
                )}
            </div>
            {error && (<p className="text-xs mt-1" style={{ color: 'var(--danger)' }}>{error}</p>)}
        </div>
    );
};

export default FormFileUpload;
